<template>
    <div ref="container" class="scale-selector">
        <div ref="track" class="scale-selector-track" @mousedown.stop="handleMD" @mousemove.stop="handleMM"
             @mouseup.stop="handleMU">
            <div ref="gauge" class="scale-selector-gauge"></div>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data () {
            return {
                moving: false
            }
        },
        destroyed: function () {

        },
        methods: {
            handleMD(event){
                this.moving = true;
                var track = this.$refs.track;
                var X = event.layerX - track.offsetLeft;
                this.$refs.gauge.style.width = X + "px";
                this.$emit('input',X);
            },
            handleMM(event){
                if (this.moving) {
                    var track = this.$refs.track;
                    var X = event.layerX - track.offsetLeft;
                    this.$refs.gauge.style.width = X + "px";
                    this.$emit('input',X);
                }


            },
            handleMU(event){
                this.moving = false;
                var track = this.$refs.track;
                var X = event.layerX - track.offsetLeft;
                this.$emit('input',X);
            }
        },
        mounted: function () {
            this.$refs.container.style.width = this.width;
            this.$refs.gauge.style.width = this.value+"px";
        },
        name: '',
        props: {
            value: {
                type: Number,
                default: 0
            },
            width: {
                type: String,
                default: '100%'
            }
        },
        updated: function () {

        },
        watch: {
            width(newValue){
                this.$refs.container.style.width = newValue;
            },
            value(newValue){
                this.$refs.gauge.style.width = newValue+"px";
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>